import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"
import _imports_0 from '../../assets/images/logo.svg'


const _hoisted_1 = {
  key: 0,
  class: "mobile-header"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Logo",
    title: "IATSE Benefits Fund Logo"
  })
], -1)
const _hoisted_3 = { class: "header-navigation" }
const _hoisted_4 = {
  class: "tooltip-wrapper",
  "data-tooltip": "Log out"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-Bell" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-user-rounded" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-Settings" }, null, -1)
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-menu" }, null, -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.isAuthenticated)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createElementVNode("i", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.performLogout && _ctx.performLogout(...args))),
              class: "plan-modal iatse-icon-noun-login"
            })
          ]),
          _createElementVNode("p", {
            class: "header-notifications plan-modal",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.openModal('alerts', 'Alerts', null)))
          }, [
            _hoisted_5,
            (_ctx.unreadAlerts)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["notification-count", {'small-padding': _ctx.unreadAlerts >= 10 }])
                }, _toDisplayString(_ctx.unreadAlerts), 3))
              : _createCommentVNode("", true)
          ]),
          (!_ctx.isSuperAdmin)
            ? (_openBlock(), _createElementBlock("p", {
                key: 0,
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleProfileOpen && _ctx.handleProfileOpen(...args))),
                class: "plan-modal"
              }, _hoisted_7))
            : _createCommentVNode("", true),
          (_ctx.isParticipant)
            ? (_openBlock(), _createElementBlock("p", {
                key: 1,
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openModal('account-settings', 'Account Settings', 'plan-card-info'))),
                class: "plan-modal"
              }, _hoisted_9))
            : _createCommentVNode("", true),
          _createElementVNode("a", {
            onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.openMenu && _ctx.openMenu(...args)), ["prevent"])),
            href: "",
            class: "mobile-menu"
          }, _hoisted_11)
        ])
      ]))
    : _createCommentVNode("", true)
}